<div
  class="bg-white border-2 border-gray-300 border-opacity-60 overflow-hidden rounded-lg h-full"
>
  <img
    class="w-full object-fit object-center"
    [src]="conference?.thumb_path || 'assets/images/no-image.jpg'"
    alt="{{ conference?.title || 'No image available' }}"
  />
  <div class="p-2">
    <h2 class="font-bold text-sm uppercase text-gray-500">
      {{ conference?.code }}
    </h2>
    <h1 class="font-medium mb-3 text-blue-950 text-xl">
      <a href="#">{{ conference?.title }}</a>
    </h1>
    <div class="flex items-right flex-wrap justify-between">
      <div class="text-gray-600">Release at: 19 October 2024</div>
      <div class="flex">
        <a
          [routerLink]="['/conferences', conference?.uuid]"
          class="px-4 py-2 mt-4 text-white bg-primary-900 rounded hover:bg-primary-900"
          >Conference Details</a
        >
      </div>
    </div>
  </div>
</div>
